import type { TemplateResult } from 'lit';
import type { PageTemplate } from './page-template-types';

export type SidebarEvent = ShowSidebarEvent | ClearSidebarEvent;

export const SidebarEventName = 'desktop-sidebar-event';
export const HeaderOptionsEventName = 'header-options-update';

export const SidebarEventType = {
  CLEAR: 'clear',
  SHOW: 'show',
} as const;

export type SidebarEventType = (typeof SidebarEventType)[keyof typeof SidebarEventType];

export type ShowSidebarEvent = {
  type: typeof SidebarEventType.SHOW;
  view: TemplateResult;
  pageTemplate: PageTemplate;
};

export type ClearSidebarEvent = {
  type: typeof SidebarEventType.CLEAR;
};
